import { useStaticQuery, graphql } from "gatsby";
import preview from "@pagerland/themes/src/RealEstate/assets/backgroundcourses-1.jpg";
import React from "react";


import '@stripe/stripe-js' // https://github.com/stripe/stripe-js#import-as-a-side-effect

import Theme, { theme } from "@pagerland/themes/src/RealEstate";
import { Helmet } from "react-helmet";
import SEO from "../components/SEO";
import WhatsAppWidget from "../components/WhatsAppWidget";
import {
  Footer,
  About,
  Reviews,
  Course,
  MontessoriCourses,
  Navbar,
  WelcomeCourses,
} from "@pagerland/themes/src/RealEstate/containers";


import PropTypes from "prop-types";

const SERVICE_CARD_ORDER = [
  "playgroup",
  "domestic-helper-child-engagement-language",
  "montessori-coaching",
];

const SERVICE_CARD_CTA = {
  playgroup: "Book trial",
  "domestic-helper-child-engagement-language": "Book & Pay",
  "montessori-coaching": "Enquire now",
};

export default function Montessori({ url }) {
  const data = useStaticQuery(graphql`
    query CombinedQuery {
      courses: allMarkdownRemark(
        filter: {frontmatter: {category: {eq: "course"}}}
      ) {
        nodes {
          id
          frontmatter {
            slug
            title
            thumb {
              childImageSharp {
                fluid {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
  `);

  const courseBySlug = new Map(
    data.courses.nodes.map((node) => [node.frontmatter.slug, node])
  );
  const serviceCards = SERVICE_CARD_ORDER
    .map((slug) => {
      const courseNode = courseBySlug.get(slug);
      if (!courseNode) {
        return null;
      }
      return {
        ...courseNode,
        serviceCta: SERVICE_CARD_CTA[slug],
      };
    })
    .filter(Boolean);

  return (
    <Theme>
      <Helmet>
        <link href={theme.typography.googleFont} rel="stylesheet" />
        <meta name="theme-color" content={theme.colors.primary} />
        <meta property="og:image" content={`${url}${preview}`} />
      </Helmet>
      <SEO title="Montessori" />
      <Navbar />
      <WhatsAppWidget showPrompt />
      <WelcomeCourses
        name="Montessori Courses"
        homepage="1"
        title="Montessori Guidance in Singapore"
        header="Playgroup, private coaching, and practical support for calm, confident parenting."
      />
      <MontessoriCourses name="register" data={serviceCards} />
      <Reviews name="reviews" />
      <Course name="venue" />
      <About name="about" />
      <Footer name="footer" />
    </Theme>
  )

}


Montessori.propTypes = {
  url: PropTypes.string,
};

Montessori.defaultProps = {
  url: "https://www.instagram.com/practicalmontessori/",
};

//export default Montessori;
